import merge from 'deepmerge';
import NumberBadgeTheme from '@polestar/component-warehouse-react/components/number-badge/NumberBadgeTheme';
import BulletListTheme from '@polestar/component-warehouse-react/components/bullet-list/BulletList.theme';
import CheckboxTheme from '@polestar/component-warehouse-react/components/checkbox/Checkbox.theme';
import RadioButtonTheme from '@polestar/component-warehouse-react/components/radio-button/RadioButton.theme';
import StepNavigationTheme from '@polestar/component-warehouse-react/components/step-navigation/StepNavigation.theme';
import TabsTheme from '@polestar/component-warehouse-react/components/tabs/Tabs.theme';
import TextTheme from '@polestar/component-warehouse-react/components/text/Text.theme';
import HeadingTheme from '@polestar/component-warehouse-react/components/heading/Heading.theme';
import TooltipTheme from '@polestar/component-warehouse-react/components/tooltip/Tooltip.theme';
import VideoPlayerTheme from '@polestar/component-warehouse-react/components/video-player/VideoPlayer.theme';
import SpinnerTheme from '@polestar/component-warehouse-react/components/spinner/Spinner.theme';
import SliderTheme from '@polestar/component-warehouse-react/components/slider/Slider.theme';
import SnackbarTheme from '@polestar/component-warehouse-react/components/snackbar/Snackbar.theme';
import TableTheme from '@polestar/component-warehouse-react/components/table/Table.theme';
import QuoteTheme from '@polestar/component-warehouse-react/components/quote/Quote.theme';
import PolestarAppTheme from '@polestar/component-warehouse-react/components/polestar-app/PolestarApp.theme';
import OptionsListTheme from '@polestar/component-warehouse-react/components/options-list/OptionsList.theme';
import NumberStepperTheme from '@polestar/component-warehouse-react/components/number-stepper/NumberStepper.theme';
import CaptionTheme from '@polestar/component-warehouse-react/components/caption/Caption.theme';
import MenuButtonTheme from '@polestar/component-warehouse-react/components/menu-button/MenuButton.theme';
import ListItemTheme from '@polestar/component-warehouse-react/components/list-item/ListItem.theme';
import AccordionTheme from '@polestar/component-warehouse-react/components/accordion/Accordion.theme';
import CardTheme from '@polestar/component-warehouse-react/components/card/Card.theme';
import ChipTheme from '@polestar/component-warehouse-react/components/chip/Chip.theme';
import DialogTheme from '@polestar/component-warehouse-react/components/dialog/Dialog.theme';
import DividerTheme from '@polestar/component-warehouse-react/components/divider/Divider.theme';
import DrawerTheme from '@polestar/component-warehouse-react/components/drawer/Drawer.theme';
import FooterTheme from '@polestar/component-warehouse-react/components/footer/Footer.theme';
import GalleryTheme from '@polestar/component-warehouse-react/components/gallery/Gallery.theme';
import HeroSectionLegacyTheme from '@polestar/component-warehouse-react/components/hero-section-legacy/HeroSectionLegacy.theme';
import HeroSectionTheme from '@polestar/component-warehouse-react/components/hero-section/HeroSection.theme';
import LinkTheme from '@polestar/component-warehouse-react/components/link/Link.theme';
import ImageTheme from '@polestar/component-warehouse-react/components/image/Image.theme';
import IndicatorTheme from '@polestar/component-warehouse-react/components/indicator/Indicator.theme';
import ScrollIndicatorTheme from '@polestar/component-warehouse-react/components/scroll-indicator/ScrollIndicator.theme';
import LabelTheme from '@polestar/component-warehouse-react/components/label/Label.theme';
import IconButtonTheme from '@polestar/component-warehouse-react/components/icon-button/IconButton.theme';
import FormFieldTheme from '@polestar/component-warehouse-react/components/form-field/FormField.theme';
import NavigationDrawerTheme from '@polestar/component-warehouse-react/components/navigation-drawer/NavigationDrawer.theme';
import SectionSpacerTheme from '@polestar/component-warehouse-react/components/section-spacer/SectionSpacer.theme';
import SkeletonTheme from '@polestar/component-warehouse-react/components/skeleton/Skeleton.theme';
import MapMarkerTheme from '@polestar/component-warehouse-react/components/maps/map-marker/MapMarker.theme';
import MapClusterTheme from '@polestar/component-warehouse-react/components/maps/map-cluster/MapCluster.theme';
import MapControlsTheme from '@polestar/component-warehouse-react/components/maps/map-controls/MapControls.theme';
import MapUserLocationMarkerTheme from '@polestar/component-warehouse-react/components/maps/map-user-location-marker/MapUserLocationMarker.theme';
import ToggleTheme from '@polestar/component-warehouse-react/components/toggle/Toggle.theme';
import FileUploadTheme from '@polestar/component-warehouse-react/components/file-upload/FileUpload.theme';
import TimePickerTheme from '@polestar/component-warehouse-react/components/time-picker/TimePicker.theme';
import TimePickerFieldTheme from '@polestar/component-warehouse-react/components/time-picker-field/TimePickerField.theme';
import DatePickerTheme from '@polestar/component-warehouse-react/components/date-picker/DatePicker.theme';
import GridTileTheme from '@polestar/component-warehouse-react/components/grid-tile/GridTile.theme';
import DatePickerFieldTheme from '@polestar/component-warehouse-react/components/date-picker-field/DatePickerField.theme';
import BackdropTheme from '@polestar/component-warehouse-react/components/backdrop/Backdrop.theme';
import ProductListIteTheme from '@polestar/component-warehouse-react/components/product-list-item/ProductListItem.theme';
import SelectableTheme from '@polestar/component-warehouse-react/components/selectable/Selectable.theme';
import SelectableFieldTheme from '@polestar/component-warehouse-react/components/selectable-field/SelectableField.theme';
import SelectionOverlayTheme from '@polestar/component-warehouse-react/components/selection-overlay/SelectionOverlay.theme';
import BarChartTheme from '@polestar/component-warehouse-react/components/bar-chart/BarChart.theme';
import MapTooltipTheme from '@polestar/component-warehouse-react/components/maps/map-tooltip/MapTooltip.theme';
import MapMarkerWithTooltipTheme from '@polestar/component-warehouse-react/components/maps/map-marker-with-tooltip/MapMarkerWithTooltip.theme';
import ContextMenuTheme from '@polestar/component-warehouse-react/components/context-menu/ContextMenu.theme';
import BannerBarTheme from '@polestar/component-warehouse-react/components/banner-bar/BannerBar.theme';
import SummaryListTheme from '@polestar/component-warehouse-react/components/summary-list/SummaryList.theme';
import TimelineTheme from '@polestar/component-warehouse-react/components/timeline/Timeline.theme';
import ScrollProgressBarTheme from '@polestar/component-warehouse-react/components/scroll-progress-bar/ScrollProgressBar.theme';
import TextAreaFieldTheme from '@polestar/component-warehouse-react/components/textarea-field/TextAreaField.theme';
import PlaceholderTheme from '@polestar/component-warehouse-react/components/placeholder/Placeholder.theme';
import LinkGridTileTheme from '@polestar/component-warehouse-react/components/grid-tile/LinkGridTile.theme';
import InfoPanelTheme from '@polestar/component-warehouse-react/components/info-panel/InfoPanel.theme';
import InternalAvatarTheme from '@polestar/component-warehouse-react/components/internal-avatar/InternalAvatar.theme';
import TimestampTheme from '@polestar/component-warehouse-react/components/timestamp/Timestamp.theme';
import CardExperimentalTheme from '@polestar/component-warehouse-react/components/card-experimental/CardExperimental.theme';
import ScrollProgressTheme from '@polestar/component-warehouse-react/components/scroll-progress/ScrollProgress.theme';
import LocationFinderSectionTheme from '@polestar/component-warehouse-react/components/location-finder-section/LocationFinderSection.theme';
import ButtonTheme from '@polestar/component-warehouse-react/components/button/Button.theme';
import InternalHeaderTheme from '@polestar/component-warehouse-react/components/internal-header/InternalHeader.theme';
import VerticalNavigationTheme from '@polestar/component-warehouse-react/components/vertical-navigation/VerticalNavigation.theme';
import PointerReplaceTheme from '@polestar/component-warehouse-react/components/pointer-replace/PointerReplace.theme';
import AudioPlayerTheme from '@polestar/component-warehouse-react/components/audio-player/AudioPlayer.theme';
import SoundPlayerThem from '@polestar/component-warehouse-react/components/sound-player/SoundPlayer.theme';
import PauseButtonTheme from '@polestar/component-warehouse-react/components/pause-button/PauseButton.theme';
import InternalSplitButtonTheme from '@polestar/component-warehouse-react/components/internal-split-button/InternalSplitButton.theme';
import StatusBadgeTheme from '@polestar/component-warehouse-react/components/status-badge/StatusBadge.theme';
import InternalStatusBadgeTheme from '@polestar/component-warehouse-react/components/internal-status-badge/InternalStatusBadge.theme';
import InternalTableTheme from '@polestar/component-warehouse-react/components/internal-table/InternalTable.theme';
import OfferBarTheme from '@polestar/component-warehouse-react/components/offer-bar/OfferBar.theme';
import SideNavigationTheme from '@polestar/component-warehouse-react/components/side-navigation/SideNavigation.theme';
import MarketSelectorTheme from '@polestar/component-warehouse-react/components/market-selector/MarketSelector.theme';
import InternalTextTheme from '@polestar/component-warehouse-react/components/internal-text/InternalText.theme';
import InternalHeadingTheme from '@polestar/component-warehouse-react/components/internal-heading/InternalHeading.theme';
import InternalLabelTheme from '@polestar/component-warehouse-react/components/internal-label/InternalLabel.theme';
import ImporterBannerTopTheme from '@polestar/component-warehouse-react/components/importer-banner-top/ImporterBannerTop.theme';
import ImporterBannerBottomTheme from '@polestar/component-warehouse-react/components/importer-banner-bottom/ImporterBannerBottom.theme';
import MegaMenuTheme from '@polestar/component-warehouse-react/components/mega-menu/MegaMenu.theme';
import KeyValuePairTheme from '@polestar/component-warehouse-react/components/key-value-pair/KeyValuePair.theme';
import ProgressCircleTheme from '@polestar/component-warehouse-react/components/progress-circle/ProgressCircle.theme';
import BannerTheme from '@polestar/component-warehouse-react/components/banner/Banner.theme';
import BadgeTheme from '@polestar/component-warehouse-react/components/badge/Badge.theme';
// Add import above
/**
 * @internal
 */
export const componentThemes = [
    StepNavigationTheme,
    TabsTheme,
    TextTheme,
    HeadingTheme,
    TooltipTheme,
    VideoPlayerTheme,
    SpinnerTheme,
    SliderTheme,
    SnackbarTheme,
    TableTheme,
    QuoteTheme,
    PolestarAppTheme,
    OptionsListTheme,
    NumberStepperTheme,
    CaptionTheme,
    MenuButtonTheme,
    ListItemTheme,
    AccordionTheme,
    NumberBadgeTheme,
    BulletListTheme,
    CardTheme,
    ChipTheme,
    CheckboxTheme,
    RadioButtonTheme,
    DialogTheme,
    DividerTheme,
    DrawerTheme,
    FooterTheme,
    GalleryTheme,
    HeroSectionLegacyTheme,
    HeroSectionTheme,
    LinkTheme,
    ImageTheme,
    IndicatorTheme,
    ScrollIndicatorTheme,
    IconButtonTheme,
    LabelTheme,
    FormFieldTheme,
    NavigationDrawerTheme,
    SectionSpacerTheme,
    SkeletonTheme,
    MapMarkerTheme,
    MapClusterTheme,
    MapControlsTheme,
    MapUserLocationMarkerTheme,
    ToggleTheme,
    FileUploadTheme,
    TimePickerTheme,
    TimePickerFieldTheme,
    DatePickerTheme,
    GridTileTheme,
    DatePickerFieldTheme,
    BackdropTheme,
    ProductListIteTheme,
    SelectableTheme,
    SelectableFieldTheme,
    SelectionOverlayTheme,
    BarChartTheme,
    MapTooltipTheme,
    MapMarkerWithTooltipTheme,
    ContextMenuTheme,
    BannerBarTheme,
    SummaryListTheme,
    TimelineTheme,
    ScrollProgressBarTheme,
    TextAreaFieldTheme,
    PlaceholderTheme,
    LinkGridTileTheme,
    InfoPanelTheme,
    InternalAvatarTheme,
    TimestampTheme,
    CardExperimentalTheme,
    ScrollProgressTheme,
    LocationFinderSectionTheme,
    ButtonTheme,
    InternalHeaderTheme,
    VerticalNavigationTheme,
    PointerReplaceTheme,
    AudioPlayerTheme,
    SoundPlayerThem,
    PauseButtonTheme,
    InternalSplitButtonTheme,
    StatusBadgeTheme,
    InternalStatusBadgeTheme,
    InternalTableTheme,
    OfferBarTheme,
    SideNavigationTheme,
    MarketSelectorTheme,
    InternalTextTheme,
    InternalHeadingTheme,
    InternalLabelTheme,
    ImporterBannerTopTheme,
    ImporterBannerBottomTheme,
    MegaMenuTheme,
    KeyValuePairTheme,
    ProgressCircleTheme,
    BannerTheme,
    BadgeTheme,
    // Add theme above
];
export var ThemeTypes;
(function (ThemeTypes) {
    ThemeTypes["light"] = "light";
    ThemeTypes["dark"] = "dark";
})(ThemeTypes || (ThemeTypes = {}));
export var ThemeExtraTypes;
(function (ThemeExtraTypes) {
    ThemeExtraTypes["followTheme"] = "followTheme";
    ThemeExtraTypes["inverted"] = "inverted";
    ThemeExtraTypes["custom"] = "custom";
    ThemeExtraTypes["transparent"] = "transparent";
})(ThemeExtraTypes || (ThemeExtraTypes = {}));
export function extendTheme(baseTheme, data, { name, type, } = {}) {
    return merge(baseTheme, {
        _name: name || `${baseTheme._name}-extended`,
        _type: type || baseTheme._type,
        ...data,
    });
}
const _themes = {
    [ThemeTypes.light]: { _name: ThemeTypes.light, _type: ThemeTypes.light },
    [ThemeTypes.dark]: { _name: ThemeTypes.dark, _type: ThemeTypes.dark },
};
componentThemes.forEach((componentTheme) => {
    for (const [key, data] of Object.entries(componentTheme)) {
        if (key in _themes.light) {
            console.warn('Theme object already in theme', key);
        }
        _themes[ThemeTypes.light][key] = data[ThemeTypes.light] || {};
        _themes[ThemeTypes.dark][key] = merge(data[ThemeTypes.light] || {}, data[ThemeTypes.dark] || {});
    }
});
/**
 * @internal
 */
export const themes = _themes;
